import React from 'react';
import { Box, Paper, Tooltip } from '@mui/material';
import { List, Star } from '@mui/icons-material';
import { codeColorMap, codeColorMapHover } from 'lib/colors';

//dx: '#ff6666',

const DraggableCodeCard = ({ code: { content, symbol_category, clinic_id, type } }) => {
    const color = codeColorMap[symbol_category] ?? codeColorMap.other;
    const hoverColor = codeColorMapHover[symbol_category] ?? codeColorMapHover.other;

    return (
        <Box sx={{ height: '80px' }}>
            <Paper
                sx={{
                    borderLeft: `25px solid ${color}`,
                    padding: 2,
                    height: '100%',
                    '&:hover': {
                        borderLeft: `25px solid ${hoverColor}`,
                    },
                    display: 'flex',
                    alignItems: 'center',
                }}
                variant="outlined"
            >
                {Boolean(clinic_id) && (
                    <Tooltip title="This is a custom, non-AVDC code" placement="top">
                        <Star
                            sx={{
                                color,
                                marginRight: 1,
                            }}
                        />
                    </Tooltip>
                )}

                {content}

                {type === 'multiselect' && (
                    <div style={{ marginLeft: 'auto' }}>
                        <Tooltip title="Multiple-choice code" placement="top">
                            <List
                                sx={{
                                    color,
                                    marginLeft: 2,
                                }}
                            />
                        </Tooltip>
                    </div>
                )}
            </Paper>
        </Box>
    );
};

export default DraggableCodeCard;
